export const stateName = 'shippingConfig';